<template>
  <div class="loading">
    <div class="wrapper">
      <cube-loading :size="28"></cube-loading>
    </div>
    <!-- <p class="desc">{{title}}</p> -->
  </div>
</template>

<script type="text/ecmascript-6">
import {
  // 基础样式
  Style,
  Button,
  Dialog
} from 'cube-ui'
  export default {
    props: {
      title: {
        type: String,
        default: '正在载入...'
      }
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .loading {
    position: fixed;
    padding-top: 10rem;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    text-align: center;
    color: #fff;
    background-color: rgba(0, 0, 0, .3);
    .wrapper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .desc {
      line-height: 20px;
      // font-size: @font-size-small;
      // color: @color-text-l;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wapmy-loading/index.vue